module.exports = __webpack_public_path__ + "static/clients-image-1-bc7a4cab9c35d7ec1aa7645542b4fff2.png";